const liftWinchPowerSrc = `
<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   width="195mm"
   height="130mm"
   viewBox="0 0 195 130"
   version="1.1"
   id="svg4534"
   inkscape:version="1.2.2 (732a01da63, 2022-12-09)"
   sodipodi:docname="питание лебёдки.svg"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"
   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
   xmlns:cc="http://creativecommons.org/ns#"
   xmlns:dc="http://purl.org/dc/elements/1.1/">
   <defs
      id="defs4528">
      <inkscape:path-effect
         effect="bspline"
         id="path-effect4945"
         is_visible="true"
         weight="33.333333"
         steps="2"
         helper_size="0"
         apply_no_weight="true"
         apply_with_weight="true"
         only_selected="false" />
      <inkscape:path-effect
         effect="bspline"
         id="path-effect4907"
         is_visible="true"
         weight="33.333333"
         steps="2"
         helper_size="0"
         apply_no_weight="true"
         apply_with_weight="true"
         only_selected="false" />
      <inkscape:path-effect
         effect="bspline"
         id="path-effect4907-6"
         is_visible="true"
         weight="33.333333"
         steps="2"
         helper_size="0"
         apply_no_weight="true"
         apply_with_weight="true"
         only_selected="false" />
   </defs>
   <sodipodi:namedview
      id="base"
      pagecolor="#646464"
      bordercolor="#666666"
      borderopacity="1.0"
      inkscape:pageopacity="0"
      inkscape:pageshadow="2"
      inkscape:zoom="2.0000001"
      inkscape:cx="349.24999"
      inkscape:cy="266.99999"
      inkscape:document-units="mm"
      inkscape:current-layer="LKMC_voltage_blue_color"
      showgrid="true"
      inkscape:snap-global="true"
      inkscape:pagecheckerboard="true"
      inkscape:showpageshadow="2"
      inkscape:deskcolor="#646464"
      inkscape:window-width="1920"
      inkscape:window-height="1017"
      inkscape:window-x="-8"
      inkscape:window-y="-8"
      inkscape:window-maximized="1">
      <inkscape:grid
         type="xygrid"
         id="grid5079"
         spacingx="0.26458333"
         spacingy="0.26458333"
         empspacing="10" />
   </sodipodi:namedview>
   <metadata
      id="metadata4531">
      <rdf:RDF>
         <cc:Work
            rdf:about="">
            <dc:format>image/svg+xml</dc:format>
            <dc:type
               rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
            <dc:title />
         </cc:Work>
      </rdf:RDF>
   </metadata>
   <g
      inkscape:label="Layer 1"
      inkscape:groupmode="layer"
      id="layer1"
      transform="translate(0,-175)">
      <rect
         style="display:none;opacity:1;fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none;stroke-width:0.52916664;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:markers fill stroke"
         id="back"
         width="195.76874"
         height="121.70834"
         x="-4.3823241e-007"
         y="176.08542"
         inkscape:label="back" />
      <g
         id="station"
         inkscape:label="station"
         transform="translate(-23.812501,8.731245)"
         style="stroke-width:1">
         <rect
            y="177.14375"
            x="37.041668"
            height="74.87709"
            width="29.104164"
            id="station_body"
            style="opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke:#000;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:markers fill stroke"
            inkscape:label="station_body" />
         <text
            inkscape:label="station_label"
            id="station_label"
            y="182.87547"
            x="51.402256"
            style="font-style:normal;font-weight:normal;font-size:10.5833px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="font-size:5.64444px;text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="182.87547"
           x="51.402256"
           id="tspan5091"
           sodipodi:role="line">Станция</tspan></text>
         <text
            inkscape:label="u_line_pin"
            id="u_line_pin"
            y="218.06982"
            x="60.943657"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="218.06982"
           x="60.943657"
           id="tspan5095"
           sodipodi:role="line">U</tspan></text>
         <text
            inkscape:label="v_line_pin"
            id="v_line_pin"
            y="212.59348"
            x="60.918472"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="212.59348"
           x="60.918472"
           id="tspan5095-5"
           sodipodi:role="line">V</tspan></text>
         <text
            inkscape:label="w_line_pin"
            id="w_line_pin"
            y="207.41582"
            x="60.22578"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="207.41582"
           x="60.22578"
           id="tspan5095-53"
           sodipodi:role="line">W</tspan></text>
         <text
            inkscape:label="lkmf1_pin"
            id="lkmf1_pin"
            y="191.75072"
            x="53.984798"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="191.75072"
           x="53.984798"
           id="tspan5095-1"
           sodipodi:role="line">LKMF1</tspan></text>
         <text
            inkscape:label="likmc_pin"
            id="lkmc_pin"
            y="196.8903"
            x="54.159931"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="196.8903"
           x="54.159931"
           id="tspan5095-0"
           sodipodi:role="line">LKMC</tspan></text>
         <text
            inkscape:label="l160_pin"
            id="l160_pin"
            y="226.01196"
            x="54.94595"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="226.01196"
           x="54.94595"
           id="tspan5095-4"
           sodipodi:role="line">L160</tspan></text>
         <text
            inkscape:label="l161_pin"
            id="l161_pin"
            y="231.17763"
            x="55.117088"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="231.17763"
           x="55.117088"
           id="tspan5095-8"
           sodipodi:role="line">L161</tspan></text>
         <text
            inkscape:label="onkmc_pin"
            id="onkmc_pin"
            y="236.58176"
            x="50.540359"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="236.58176"
           x="50.540359"
           id="tspan5095-51"
           sodipodi:role="line">ONKMC</tspan></text>
         <text
            inkscape:label="run_pin"
            id="run_pin"
            y="244.49446"
            x="56.156235"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="244.49446"
           x="56.156235"
           id="tspan5095-3"
           sodipodi:role="line">RUN</tspan></text>
         <text
            inkscape:label="embrk_pin"
            id="embrk_pin"
            y="249.7995"
            x="50.864971"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="249.7995"
           x="50.864971"
           id="tspan5095-7"
           sodipodi:role="line">EMBRK</tspan></text>
         <text
            inkscape:label="station_ready_pin"
            id="station_ready_pin"
            y="244.57684"
            x="39.145977"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="244.57684"
           x="39.145977"
           id="tspan5095-09"
           sodipodi:role="line">READY</tspan></text>
         <text
            inkscape:label="station_brk_pin"
            id="station_brk_pin"
            y="249.89717"
            x="39.276176"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="249.89717"
           x="39.276176"
           id="tspan5095-56"
           sodipodi:role="line">BRK</tspan></text>
         <text
            inkscape:label="brc0_pin"
            id="brc0_pin"
            y="191.70656"
            x="39.663834"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="191.70656"
           x="39.663834"
           sodipodi:role="line"
           id="tspan5021">BRC0</tspan></text>
         <text
            inkscape:label="brc1_pin"
            id="brc1_pin"
            y="197.00995"
            x="39.375175"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="197.00995"
           x="39.375175"
           id="tspan5095-7-1"
           sodipodi:role="line">BRC1</tspan></text>
         <text
            inkscape:label="brc2_pin"
            id="brc2_pin"
            y="202.33469"
            x="39.226349"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="202.33469"
           x="39.226349"
           id="tspan5095-7-8"
           sodipodi:role="line">BRC2</tspan></text>
      </g>
      <g
         id="kmc_kontaktor"
         inkscape:label="kmc_kontaktor"
         transform="translate(-18.520841,21.166666)"
         style="stroke-width:1">
         <g
            id="kmc_34_switch"
            inkscape:label="kmc_34_switch"
            transform="translate(-2.6458276,7.9374988)"
            style="stroke-width:1">
            <path
               d="m 100.17416,191.16667 a 0.36750001,0.36750001 0 0 1 0.3675,-0.3675 0.36750001,0.36750001 0 0 1 0.3675,0.3675 h -0.3675 z"
               sodipodi:end="0"
               sodipodi:start="3.1415927"
               sodipodi:ry="0.36750001"
               sodipodi:rx="0.36750001"
               sodipodi:cy="191.16667"
               sodipodi:cx="100.54166"
               sodipodi:type="arc"
               id="path5279-7"
               style="opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke:#000;stroke-width:0.26499999;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:markers fill stroke" />
         </g>
         <g
            id="kmc_56_switch"
            inkscape:label="kmc_56_switch"
            transform="translate(-2.6458267,13.229163)"
            style="stroke-width:1">
            <path
               d="m 100.17416,191.16667 a 0.36750001,0.36750001 0 0 1 0.3675,-0.3675 0.36750001,0.36750001 0 0 1 0.3675,0.3675 h -0.3675 z"
               sodipodi:end="0"
               sodipodi:start="3.1415927"
               sodipodi:ry="0.36750001"
               sodipodi:rx="0.36750001"
               sodipodi:cy="191.16667"
               sodipodi:cx="100.54166"
               sodipodi:type="arc"
               id="path5279-3"
               style="opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke:#000;stroke-width:0.26499999;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:markers fill stroke" />
         </g>
         <g
            id="kmc_2221_switch"
            inkscape:label="kmc_2221_switch"
            transform="translate(-2.6458336,18.520835)"
            style="stroke-width:1">
            <path
               inkscape:label="kmc_2221_line"
               inkscape:connector-curvature="0"
               id="kmc_2221_line"
               d="m 92.604171,191.16667 8.466669,-2.91041"
               style="fill:none;stroke:#000;stroke-width:0.26499999;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" />
         </g>
         <rect
            transform="translate(0,-1.1666667e-6)"
            style="fill:var(--error-bg);"
            hidden="true"
            id="kmc_body_fill"
            width="26.458342"
            height="50.270828"
            x="79.374992"
            y="164.70834"
            inkscape:label="kmc_body_fill" />
         <rect
            transform="translate(0,-1.1666667e-6)"
            style="opacity:1;fill:transparent;fill-opacity:1;fill-rule:evenodd;stroke:#000;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:markers fill stroke"
            id="kmc_body"
            width="26.458342"
            height="50.270828"
            x="79.374992"
            y="164.70834"
            inkscape:label="kmc_body" />
         <g
            id="kmc_12_switch"
            inkscape:label="kmc_12_switch"
            transform="translate(-2.6458267,2.6458322)"
            style="stroke-width:1">
            <g
               id="onkmc_1_hide"
               inkscape:label="onkmc_1_hide">
               <title
                  id="title1342">onkmc_1_hide</title>
               <path
                  inkscape:label="kmc_34_opened"
                  inkscape:connector-curvature="0"
                  id="kmc_34_opened"
                  d="m 92.604167,191.16667 7.937493,-2.64583"
                  style="stroke-width:0.26499999;fill:none;stroke:#000;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                  transform="translate(-8.1874999e-7,5.2916676)" />
               <path
                  inkscape:label="kmc_56_opened"
                  inkscape:connector-curvature="0"
                  id="kmc_56_opened-0"
                  d="m 92.604167,191.16667 7.937493,-2.64583"
                  style="stroke-width:0.26499999;fill:none;stroke:#000;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                  transform="translate(-2.4999995e-8,10.583332)" />
               <path
                  style="stroke-width:0.26458332px;fill:none;stroke:#000;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                  d="m 100.54167,191.16667 v -3.17501"
                  id="kmc_2221_closing_pin"
                  inkscape:connector-curvature="0"
                  inkscape:label="kmc_2221_closing_pin"
                  transform="translate(-6.9041667e-6,15.875004)" />
               <path
                  inkscape:label="kmc_12_opened"
                  inkscape:connector-curvature="0"
                  id="kmc_12_opened"
                  d="m 92.604167,191.16667 7.937493,-2.64583"
                  style="fill:none;stroke:#000;stroke-width:0.26499999;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" />
            </g>
            <path
               d="m 100.17416,191.16667 a 0.36750001,0.36750001 0 0 1 0.3675,-0.3675 0.36750001,0.36750001 0 0 1 0.3675,0.3675 h -0.3675 z"
               sodipodi:end="0"
               sodipodi:start="3.1415927"
               sodipodi:ry="0.36750001"
               sodipodi:rx="0.36750001"
               sodipodi:cy="191.16667"
               sodipodi:cx="100.54166"
               sodipodi:type="arc"
               id="path5279"
               style="opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke:#000;stroke-width:0.26499999;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:markers fill stroke" />
            <g
               id="onkmc_0_hide"
               inkscape:label="onkmc_0_hide">
               <title
                  id="title1331">onkmc_0_hide</title>
               <path
                  inkscape:label="kmc_34_closed"
                  inkscape:connector-curvature="0"
                  id="kmc_34_closed-9"
                  hidden='true'
                  d="m 92.604166,191.16667 h 7.937504"
                  style="stroke-width:0.26458332px;fill:none;stroke:var(--text-link);stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                  transform="translate(-8.1874999e-7,5.2916676)" />
               <path
                  inkscape:label="kmc_56_closed"
                  inkscape:connector-curvature="0"
                  id="kmc_56_closed-5"
                  hidden='true'
                  d="m 92.604166,191.16667 h 7.937504"
                  style="stroke-width:0.26458332px;fill:none;stroke:var(--text-link);stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                  transform="translate(-2.4999995e-8,10.583332)" />
               <path
                  inkscape:label="kmc_12_closed"
                  inkscape:connector-curvature="0"
                  id="kmc_12_closed"
                  hidden='true'
                  d="m 92.604166,191.16667 h 7.937504"
                  style="fill:none;stroke:var(--text-link);stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
            </g>
         </g>
         <text
            xml:space="preserve"
            style="font-style:normal;font-weight:normal;font-size:10.5833px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            x="92.790649"
            y="172.14095"
            id="kmc_label"
            inkscape:label="kmc_label"><tspan
           sodipodi:role="line"
           id="tspan5091-8"
           x="92.790649"
           y="172.14095"
           style="font-size:5.64444px;text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583">KMC</tspan></text>
         <rect
            inkscape:label="kmc_relay"
            y="177.9375"
            x="89.958336"
            height="10.583328"
            width="5.2916694"
            id="kmc_relay"
            style="opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke:#000;stroke-width:0.26499999;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:markers fill stroke" />
         <text
            xml:space="preserve"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            x="84.741638"
            y="182.47383"
            id="kmc_A1_pin"
            inkscape:label="kmc_A1_pin"><tspan
           sodipodi:role="line"
           id="tspan5095-4-9"
           x="84.741638"
           y="182.47383"
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583">A1</tspan></text>
         <text
            xml:space="preserve"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            x="100.6194"
            y="182.36752"
            id="kmc_A2_pin"
            inkscape:label="kmc_A2_pin"><tspan
           sodipodi:role="line"
           id="tspan5095-4-9-6"
           x="100.6194"
           y="182.36752"
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583">A2</tspan></text>
         <text
            xml:space="preserve"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            x="84.504974"
            y="193.35873"
            id="kmc_1_pin"
            inkscape:label="kmc_1_pin"><tspan
           sodipodi:role="line"
           id="tspan5095-4-9-2"
           x="84.504974"
           y="193.35873"
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583">1</tspan></text>
         <text
            xml:space="preserve"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            x="84.537018"
            y="198.51115"
            id="kmc_3_pin"
            inkscape:label="kmc_3_pin"><tspan
           sodipodi:role="line"
           id="tspan5095-4-9-66"
           x="84.537018"
           y="198.51115"
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583">3</tspan></text>
         <text
            xml:space="preserve"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            x="84.634064"
            y="203.79642"
            id="kmc_5_pin"
            inkscape:label="kmc_5_pin"><tspan
           sodipodi:role="line"
           id="tspan5095-4-9-7"
           x="84.634064"
           y="203.79642"
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583">5</tspan></text>
         <text
            xml:space="preserve"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            x="84.829796"
            y="209.00775"
            id="kmc_22_pin"
            inkscape:label="kmc_22_pin"><tspan
           sodipodi:role="line"
           id="tspan5095-4-9-3"
           x="84.829796"
           y="209.00775"
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583">22</tspan></text>
         <text
            xml:space="preserve"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            x="102.17516"
            y="193.19554"
            id="kmc_2_pin"
            inkscape:label="kmc_2_pin"><tspan
           sodipodi:role="line"
           id="tspan5095-4-9-8"
           x="102.17516"
           y="193.19554"
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583">2</tspan></text>
         <text
            xml:space="preserve"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            x="102.11895"
            y="198.62759"
            id="kmc_4_pin"
            inkscape:label="kmc_4_pin"><tspan
           sodipodi:role="line"
           id="tspan5095-4-9-5"
           x="102.11895"
           y="198.62759"
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583">4</tspan></text>
         <text
            xml:space="preserve"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            x="102.23759"
            y="203.94051"
            id="kmc_6_pin"
            inkscape:label="kmc_6_pin"><tspan
           sodipodi:role="line"
           id="tspan5095-4-9-9"
           x="102.23759"
           y="203.94051"
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583">6</tspan></text>
         <text
            xml:space="preserve"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            x="102.38167"
            y="209.21091"
            id="kmc_21_pin"
            inkscape:label="kmc_21_pin"><tspan
           sodipodi:role="line"
           id="tspan5095-4-9-4"
           x="102.38167"
           y="209.21091"
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583">21</tspan></text>
      </g>
      <g
         transform="translate(31.749993,-38.89374)"
         inkscape:label="kmf_kontaktor"
         id="kmf_kontaktor"
         style="stroke-width:1">
         <g
            transform="translate(-2.6458275,67.997905)"
            inkscape:label="kmf_34_switch"
            id="kmf_34_switch"
            style="stroke-width:1">
            <path
               style="opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke:#000;stroke-width:0.26499999;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:markers fill stroke"
               id="path5581"
               sodipodi:type="arc"
               sodipodi:cx="100.54166"
               sodipodi:cy="191.16667"
               sodipodi:rx="0.36750001"
               sodipodi:ry="0.36750001"
               sodipodi:start="3.1415927"
               sodipodi:end="0"
               d="m 100.17416,191.16667 a 0.36750001,0.36750001 0 0 1 0.3675,-0.3675 0.36750001,0.36750001 0 0 1 0.3675,0.3675 h -0.3675 z" />
         </g>
         <g
            transform="translate(-2.6458273,83.872903)"
            inkscape:label="kmf_5354_switch"
            id="kmf_5354_switch"
            style="stroke-width:1" />
         <g
            transform="translate(-2.6458321,89.16457)"
            inkscape:label="kmf_6162_switch"
            id="kmf_6162_switch"
            style="stroke-width:1">
            <path
               style="fill:none;stroke:#000;stroke-width:0.26499999;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
               d="m 92.604171,191.16667 8.466669,-2.91041"
               id="kmf_6162_line"
               inkscape:connector-curvature="0"
               inkscape:label="kmf_6162_line" />
         </g>
         <rect
            inkscape:label="kmf_body_fill"
            y="224.76875"
            x="79.374992"
            height="60.854156"
            hidden="true"
            width="26.458342"
            id="kmf_body_fill"
            style="fill:var(--error-bg);" />
         <rect
            inkscape:label="kmf_body"
            y="224.76875"
            x="79.374992"
            height="60.854156"
            width="26.458342"
            id="kmf_body"
            style="opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke:#000;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:markers fill stroke" />
         <g
            transform="translate(-2.6458266,62.706239)"
            inkscape:label="kmf_12_switch"
            id="kmf_12_switch"
            style="stroke-width:1">
            <path
               style="opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke:#000;stroke-width:0.26499999;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:markers fill stroke"
               id="path5605"
               sodipodi:type="arc"
               sodipodi:cx="100.54166"
               sodipodi:cy="191.16667"
               sodipodi:rx="0.36750001"
               sodipodi:ry="0.36750001"
               sodipodi:start="3.1415927"
               sodipodi:end="0"
               d="m 100.17416,191.16667 a 0.36750001,0.36750001 0 0 1 0.3675,-0.3675 0.36750001,0.36750001 0 0 1 0.3675,0.3675 h -0.3675 z" />
            <g
               id="run_0_hide"
               inkscape:label="run_0_hide">
               <title
                  id="title1362">run_0_hide</title>
               <path
                  style="stroke-width:0.26458332px;fill:none;stroke:var(--text-link);stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                  d="m 92.604166,191.16667 h 7.937504"
                  id="kmf_34_closed"
                  hidden='true'
                  inkscape:connector-curvature="0"
                  inkscape:label="kmf_34_closed"
                  transform="translate(2.6666666e-7,5.2916668)" />
               <path
                  style="stroke-width:0.26458332px;fill:none;stroke:var(--text-link);stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                  d="m 92.604166,191.16667 h 7.937504"
                  id="kmf_5354_closed"
                  hidden='true'
                  inkscape:connector-curvature="0"
                  inkscape:label="kmf_5354_closed"
                  transform="translate(2.6666666e-7,21.166664)" />
               <path
                  style="fill:none;stroke:var(--text-link);stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                  d="m 92.604166,191.16667 h 7.937504"
                  hidden='true'
                  id="kmf_12_closed"
                  inkscape:connector-curvature="0"
                  inkscape:label="kmf_12_closed" />
            </g>
         </g>
         <text
            inkscape:label="kmf_label"
            id="kmf_label"
            y="232.20135"
            x="92.790649"
            style="font-style:normal;font-weight:normal;font-size:10.5833px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="font-size:5.64444px;text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="232.20135"
           x="92.790649"
           id="tspan5611"
           sodipodi:role="line">KMF</tspan></text>
         <rect
            style="opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke:#000;stroke-width:0.26499999;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:markers fill stroke"
            id="kmf_relay"
            width="5.2916694"
            height="10.583328"
            x="89.958336"
            y="237.99791"
            inkscape:label="kmf_relay" />
         <text
            inkscape:label="kmf_A1_pin"
            id="kmf_A1_pin"
            y="242.40195"
            x="84.725105"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="242.40195"
           x="84.725105"
           id="tspan5617"
           sodipodi:role="line">A1</tspan></text>
         <text
            inkscape:label="kmf_A2_pin"
            id="kmf_A2_pin"
            y="242.24603"
            x="100.48711"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="242.24603"
           x="100.48711"
           id="tspan5621"
           sodipodi:role="line">A2</tspan></text>
         <text
            inkscape:label="kmf_1_pin"
            id="kmf_1_pin"
            y="253.41914"
            x="84.504974"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="253.41914"
           x="84.504974"
           id="tspan5625"
           sodipodi:role="line">1</tspan></text>
         <text
            inkscape:label="kmf_3_pin"
            id="kmf_3_pin"
            y="258.57156"
            x="84.537018"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="258.57156"
           x="84.537018"
           id="tspan5629"
           sodipodi:role="line">3</tspan></text>
         <text
            inkscape:label="kmc_5_pin"
            id="text5635"
            y="274.44016"
            x="84.634064"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="274.44016"
           x="84.634064"
           id="tspan5633"
           sodipodi:role="line">54</tspan></text>
         <text
            inkscape:label="kmf_62_pin"
            id="kmf_62_pin"
            y="279.91605"
            x="84.300629"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="279.91605"
           x="84.300629"
           id="tspan5637"
           sodipodi:role="line">62</tspan></text>
         <text
            inkscape:label="kmf_2_pin"
            id="kmf_2_pin"
            y="253.25595"
            x="102.17516"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="253.25595"
           x="102.17516"
           id="tspan5641"
           sodipodi:role="line">2</tspan></text>
         <text
            inkscape:label="kmf_4_pin"
            id="kmf_4_pin"
            y="258.68799"
            x="102.11895"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="258.68799"
           x="102.11895"
           id="tspan5645"
           sodipodi:role="line">4</tspan></text>
         <text
            inkscape:label="kmc_6_pin"
            id="text5651"
            y="274.45059"
            x="102.271"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="274.45059"
           x="102.271"
           id="tspan5649"
           sodipodi:role="line">53</tspan></text>
         <text
            inkscape:label="kmf_61_pin"
            id="kmf_61_pin"
            y="280.03366"
            x="101.8525"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="280.03366"
           x="101.8525"
           id="tspan5653"
           sodipodi:role="line">61</tspan></text>
         <g
            transform="translate(-2.6458332,73.289576)"
            inkscape:label="kmf_R1R2_switch"
            id="kmf_R1R2_switch"
            style="stroke-width:1">
            <path
               style="fill:none;stroke:#000;stroke-width:0.26499999;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
               d="m 92.604171,191.16667 8.466669,-2.91041"
               id="kmf_R1R2_line"
               inkscape:connector-curvature="0"
               inkscape:label="kmf_R1R2_line" />
            <path
               style="opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke:#000;stroke-width:0.26499999;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:markers fill stroke"
               id="path5581-9"
               sodipodi:type="arc"
               sodipodi:cx="100.54167"
               sodipodi:cy="190.6375"
               sodipodi:rx="0.36750001"
               sodipodi:ry="0.36750001"
               sodipodi:start="4.712389"
               sodipodi:end="1.5707963"
               d="m 100.54167,190.27 a 0.36750001,0.36750001 0 0 1 0.3675,0.3675 0.36750001,0.36750001 0 0 1 -0.3675,0.3675 l 0,-0.3675 z" />
         </g>
         <text
            inkscape:label="kmf_R1_pin"
            id="kmf_R1_pin"
            y="263.78595"
            x="84.806175"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="263.78595"
           x="84.806175"
           id="tspan5637-4"
           sodipodi:role="line">R1</tspan></text>
         <text
            inkscape:label="kmf_R2_pin"
            id="kmf_R2_pin"
            y="263.80905"
            x="102.16906"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="263.80905"
           x="102.16906"
           id="tspan5653-5"
           sodipodi:role="line">R2</tspan></text>
         <path
            style="opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke:#000;stroke-width:0.26499999;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:markers fill stroke"
            id="path5581-9-8"
            sodipodi:type="arc"
            sodipodi:cx="97.895836"
            sodipodi:cy="269.21872"
            sodipodi:rx="0.36750001"
            sodipodi:ry="0.36750001"
            sodipodi:start="4.712389"
            sodipodi:end="1.5707963"
            d="m 97.895836,268.85122 a 0.36750001,0.36750001 0 0 1 0.3675,0.3675 0.36750001,0.36750001 0 0 1 -0.3675,0.3675 l 0,-0.3675 z" />
         <g
            transform="translate(-2.6458314,78.581236)"
            inkscape:label="kmf_R3R4_switch"
            id="kmf_R3R4_switch"
            style="stroke-width:1">
            <path
               style="fill:none;stroke:#000;stroke-width:0.26499999;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
               d="m 92.604171,191.16667 8.466669,-2.91041"
               id="kmf_R3R4_line"
               inkscape:connector-curvature="0"
               inkscape:label="kmf_R3R4_line" />
            <g
               id="run_1_hide"
               inkscape:label="run_1_hide">
               <title
                  id="title1377">run_1_hide</title>
               <path
                  style="stroke-width:0.26499999;fill:none;stroke:#000;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                  d="m 92.604167,191.16667 7.937493,-2.64583"
                  id="kmf_34_opened"
                  inkscape:connector-curvature="0"
                  inkscape:label="kmf_34_opened"
                  transform="translate(5.0666667e-6,-10.58333)" />
               <path
                  style="stroke-width:0.26499999;fill:none;stroke:#000;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                  d="m 92.604167,191.16667 7.937493,-2.64583"
                  id="kmf_5354_opened"
                  inkscape:connector-curvature="0"
                  inkscape:label="kmf_5354_opened"
                  transform="translate(5.0666667e-6,5.2916672)" />
               <path
                  inkscape:label="kmf_6162_closing_pin"
                  inkscape:connector-curvature="0"
                  id="kmf_6162_closing_pin"
                  d="m 100.54167,191.16667 v -3.17501"
                  style="stroke-width:0.26458332px;fill:none;stroke:#000;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                  transform="translate(-2.2500001e-7,10.583334)" />
               <path
                  style="stroke-width:0.26499999;fill:none;stroke:#000;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
                  d="m 92.604167,191.16667 7.937493,-2.64583"
                  id="kmf_12_opened"
                  inkscape:connector-curvature="0"
                  inkscape:label="kmf_12_opened"
                  transform="translate(5.0666667e-6,-15.874997)" />
               <path
                  inkscape:label="kmf_R1R2_closing_pin"
                  inkscape:connector-curvature="0"
                  id="kmf_R1R2_closing_pin"
                  d="m 100.54167,191.16667 v -3.17501"
                  style="stroke-width:0.26458332px;fill:none;stroke:#000;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
                  transform="translate(-2.8708333e-6,-5.2916609)" />
               <path
                  inkscape:label="kmf_R3R4_closing_pin"
                  inkscape:connector-curvature="0"
                  id="kmf_R3R4_closing_pin"
                  d="m 100.54167,191.16667 v -3.17501"
                  style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
            </g>
         </g>
         <text
            inkscape:label="kmf_R3_pin"
            id="kmf_R3_pin"
            y="269.06815"
            x="84.829796"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="269.06815"
           x="84.829796"
           id="tspan5637-4-8"
           sodipodi:role="line">R3</tspan></text>
         <text
            inkscape:label="kmf_R4_pin"
            id="kmf_R4_pin"
            y="269.18576"
            x="102.38167"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="269.18576"
           x="102.38167"
           id="tspan5653-5-1"
           sodipodi:role="line">R4</tspan></text>
      </g>
      <g
         id="frequency_converter"
         inkscape:label="frequency_converter"
         transform="translate(-66.145826,101.3354)"
         style="stroke-width:1">
         <rect
            style="opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke:#000;stroke-width:0.49999997;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:markers fill stroke"
            id="fc_body"
            width="26.458342"
            height="23.812504"
            x="79.374992"
            y="163.9146"
            inkscape:label="fc_body" />
         <text
            xml:space="preserve"
            style="font-style:normal;font-weight:normal;font-size:10.5833px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            x="92.790649"
            y="171.3472"
            id="fc_label"
            inkscape:label="fc_label"><tspan
           sodipodi:role="line"
           id="tspan5091-8-6"
           x="92.790649"
           y="171.3472"
           style="font-size:5.64444px;text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583">ПЧ</tspan></text>
         <text
            xml:space="preserve"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            x="85.252121"
            y="178.39452"
            id="fc_brk_pin"
            inkscape:label="fc_brk_pin"><tspan
           sodipodi:role="line"
           id="tspan5095-4-9-44"
           x="85.252121"
           y="178.39452"
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583">BRK</tspan></text>
         <text
            xml:space="preserve"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            x="100.72665"
            y="178.15657"
            id="fc_mc1_pin"
            inkscape:label="fc_mc1_pin"><tspan
           sodipodi:role="line"
           id="tspan5095-4-9-6-8"
           x="100.72665"
           y="178.15657"
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583">MC1</tspan></text>
         <text
            xml:space="preserve"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            x="87.499733"
            y="183.65752"
            id="fc_ready_pin"
            inkscape:label="fc_ready_pin"><tspan
           sodipodi:role="line"
           id="tspan5095-4-9-2-4"
           x="87.499733"
           y="183.65752"
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583">READY</tspan></text>
         <text
            xml:space="preserve"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            x="100.61916"
            y="183.42223"
            id="fc_mc2_pin"
            inkscape:label="fc_mc2_pin"><tspan
           sodipodi:role="line"
           id="tspan5095-4-9-8-7"
           x="100.61916"
           y="183.42223"
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583">MC2</tspan></text>
      </g>
      <g
         id="drive"
         transform="translate(61.725192,-55.558243)"
         inkscape:label="drive"
         style="stroke-width:1">
         <rect
            inkscape:label="kmc_relay"
            y="291.70407"
            x="112.8998"
            height="10.583328"
            width="5.2916694"
            id="kmc_relay-9"
            style="opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke:#000;stroke-width:0.26499999;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:markers fill stroke" />
         <circle
            cy="259.83475"
            cx="115.51632"
            id="drive_circle"
            style="opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke:#000;stroke-width:0.26499996;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:markers fill stroke"
            inkscape:label="drive_circle"
            r="9.8675003" />
         <text
            id="drive_M_letter"
            y="264.34805"
            x="115.6074"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"
            inkscape:label="drive_M_letter"><tspan
           style="font-size:12.7px;text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="264.34805"
           x="115.6074"
           id="tspan5891"
           sodipodi:role="line">M</tspan></text>
         <path
            inkscape:label="drive_v_pin"
            inkscape:connector-curvature="0"
            id="drive_v_pin"
            d="M 105.62919,259.95835 H 97.895834"
            style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            sodipodi:nodetypes="cc" />
         <text
            inkscape:label="drive_v_pin_label"
            id="drive_v_pin_label"
            y="259.5748"
            x="98.982155"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="259.5748"
           x="98.982155"
           id="tspan5095-4-9-8-7-5"
           sodipodi:role="line">V</tspan></text>
         <text
            inkscape:label="drive_u_pin_label"
            id="drive_u_pin_label"
            y="254.27393"
            x="99.004639"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="254.27393"
           x="99.004639"
           id="tspan5095-4-9-8-7-5-9"
           sodipodi:role="line">U</tspan></text>
         <text
            inkscape:label="drive_w_pin_label"
            id="drive_w_pin_label"
            y="264.84073"
            x="99.070786"
            style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;fill:#000;fill-opacity:1;stroke:none;stroke-width:0.264583"
            xml:space="preserve"><tspan
           style="text-align:center;text-anchor:middle;fill:#000;fill-opacity:1;stroke-width:0.264583"
           y="264.84073"
           x="99.070786"
           id="tspan5095-4-9-8-7-5-6"
           sodipodi:role="line">W</tspan></text>
         <path
            inkscape:label="drive_u_pin"
            inkscape:connector-curvature="0"
            id="drive_u_pin"
            d="M 107.11703,254.66242 H 97.897068"
            style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            sodipodi:nodetypes="cc" />
         <path
            inkscape:label="drive_w_pin"
            inkscape:connector-curvature="0"
            id="drive_w_pin"
            d="M 107.26028,265.25339 H 97.894798"
            style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            sodipodi:nodetypes="cc" />
         <defs>
         <mask id="brake-mask">
            <rect width="100%" height="100%" fill="black"/>

            <path
               d="m 121.11672,267.74015
                  a 9.8677082,9.8677082 0 0 1 -7.5591,3.52487
                  9.8677082,9.8677082 0 0 1 -7.55911,-3.52487
                  m -7.58568,-0.01394
                  v 5.4901
                  l 15.12931,-0.0396
                  0.009,-5.48114
                  z"
               fill="white"/>
         </mask>
         </defs>
         <g
         id="brake1"
         transform="translate(-0.14727766,-0.25805003)">
            <path
               id="brake1-fill"
               d="
                  M 107.97194 267.72621
                  V 273.21631
                  L 123.10125 273.17671
                  L 123.11025 267.69557
                  a 9.8677082 9.8677082 0 0 1 -7.5591 3.52487
                  a 9.8677082 9.8677082 0 0 1 -7.55911 -3.52487
                  Z
               "
               fill="#fff"
            />
            <path
               stroke="var(--success-border)"
               id="brake1-stroke-1"
               d="m 107.97194,267.72621
                  v 5.4901
                  l 15.12931,-0.0396
                  0.009,-5.48114"
               style="fill:none;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            />

            <path
               stroke="var(--success-border)"
               id="brake1-stroke-2"
               d="m 123.11672,267.74015
                  a 9.8677082,9.8677082 0 0 1 -7.5591,3.52487
                  9.8677082,9.8677082 0 0 1 -7.55911,-3.52487"
               fill="none"
               style="fill:none;stroke-width:0.26499999;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            />
         </g>
         <g
            style="stroke-width:1"
            id="brake2"
            inkscape:label="brake2"
            transform="rotate(180,115.48699,259.95081)">
            <path
               stroke="var(--success-border)"
               sodipodi:open="true"
               d="m 123.11672,267.74015 a 9.8677082,9.8677082 0 0 1 -7.5591,3.52487 9.8677082,9.8677082 0 0 1 -7.55911,-3.52487"
               sodipodi:end="2.443461"
               sodipodi:start="0.6981317"
               sodipodi:ry="9.8677082"
               sodipodi:rx="9.8677082"
               sodipodi:cy="261.39731"
               sodipodi:cx="115.55762"
               sodipodi:type="arc"
               id="path4951-6"
               style="opacity:1;fill:none;fill-opacity:1;fill-rule:evenodd;stroke-width:0.26499999;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;paint-order:markers fill stroke" />
            <path
               stroke="var(--success-border)"
               sodipodi:nodetypes="cccc"
               inkscape:connector-curvature="0"
               id="path4953-1"
               d="m 107.97194,267.72621 v 5.4901 l 15.12931,-0.0396 0.009,-5.48114"
               style="fill:none;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
         </g>
         <g
            id="kin_conn"
            inkscape:label="kin_conn"
            transform="translate(-61.989774,55.02908)">
            <path
               sodipodi:nodetypes="cc"
               inkscape:connector-curvature="0"
               id="path4939"
               d="M 177.27083,236.14583 V 217.625"
               style="fill:none;stroke:#000;stroke-width:0.26499999;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:1.05999995, 1.05999995;stroke-dashoffset:0;stroke-opacity:1" />
            <path
               sodipodi:nodetypes="cccc"
               inkscape:connector-curvature="0"
               id="path4941"
               d="m 184.94375,193.54791 5.55625,1e-5 v 34.66041 h -13.22917"
               style="fill:none;stroke:#000;stroke-width:0.26458332;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:0.79374995, 0.79374995;stroke-dashoffset:0;stroke-opacity:1" />
         </g>
      </g>
      <path
         style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
         d="m 90.752083,203.33751 1.852083,1.05833 -1.852083,1.05834"
         id="arrow_kmc_a2"
         inkscape:connector-curvature="0"
         inkscape:label="arrow_kmc_a2" />
      <text
         xml:space="preserve"
         style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.264583"
         x="92.967972"
         y="205.55341"
         id="n_kmc_a2"
         inkscape:label="n_kmc_a2"><tspan
         sodipodi:role="line"
         id="tspan4654"
         x="92.967972"
         y="205.55341"
         style="fill:#000;fill-opacity:1;stroke-width:0.264583">N</tspan></text>
      <path
         style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
         d="m 42.333333,199.10418 h 2.645834 l -10e-7,79.37499 H 39.6875"
         id="lkmf_line_1"
         inkscape:connector-curvature="0"
         inkscape:label="lkmf_line_1"
         sodipodi:nodetypes="cccc" />
      <path
         style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
         d="m 140.95676,203.33751 1.85209,1.05833 -1.85209,1.05834"
         id="arrow_kmf_a2"
         inkscape:connector-curvature="0"
         inkscape:label="arrow_kmf_a2" />
      <text
         xml:space="preserve"
         style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.264583"
         x="143.17265"
         y="205.55341"
         id="n_kmf_a2"
         inkscape:label="n_kmf_a2"><tspan
         sodipodi:role="line"
         id="tspan4654-6"
         x="143.17265"
         y="205.55341"
         style="fill:#000;fill-opacity:1;stroke-width:0.264583">N</tspan></text>
      <path
         style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
         d="m 13.229166,257.3125 h -2.645833 v 21.16667 h 2.645834"
         id="brk_line"
         inkscape:connector-curvature="0"
         inkscape:label="brk_line"
         sodipodi:nodetypes="cccc" />
      <path
         style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
         d="M 13.229167,252.02084 H 7.9374999 v 31.74999 h 5.2916671"
         id="ready_line"
         inkscape:connector-curvature="0"
         inkscape:label="ready_line"
         sodipodi:nodetypes="cccc" />
      <path
         style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
         d="m 71.437499,220.27084 -29.108688,0.002"
         id="station_v_line"
         inkscape:connector-curvature="0"
         inkscape:label="station_v_line" />
      <path
         style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
         d="M 71.437499,214.97917 H 42.333333"
         id="station_w_line"
         inkscape:connector-curvature="0"
         inkscape:label="station_w_line" />
      <path
         style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
         d="m 42.333333,225.5625 h 5.291666 v 10.58334 h 5.291667 v 3.43959 h 39.6875 v -5.29166 H 103.1875 v -19.3146 h 18.52083"
         id="station_u_line"
         inkscape:connector-curvature="0"
         inkscape:label="station_u_line"
         sodipodi:nodetypes="cccccccccc" />
      <path
         style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
         d="M 71.437499,225.5625 H 50.270833 V 233.5 h -7.9375"
         id="l160_line_1"
         inkscape:connector-curvature="0"
         inkscape:label="l160_line_1" />
      <path
         style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
         d="M 79.374999,230.85417 H 89.958332"
         id="onkmc_line_1"
         inkscape:connector-curvature="0"
         inkscape:label="onkmc_line_1" />
      <path
         style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
         d="m 88.370833,229.79584 1.852083,1.05833 -1.852083,1.05834"
         id="arrow_21"
         inkscape:connector-curvature="0"
         inkscape:label="arrow_21" />
      <text
         xml:space="preserve"
         style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.264583"
         x="90.586723"
         y="232.01175"
         id="0v_21"
         inkscape:label="0v_21"><tspan
         sodipodi:role="line"
         id="tspan4654-8"
         x="90.586723"
         y="232.01175"
         style="fill:#000;fill-opacity:1;stroke-width:0.264583">0V</tspan></text>
      <path
         style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
         d="m 138.64166,235.08751 1.85208,1.05833 -1.85208,1.05834"
         id="arrow_53"
         inkscape:connector-curvature="0"
         inkscape:label="arrow_53" />
      <text
         xml:space="preserve"
         style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.264583"
         x="140.85754"
         y="237.30342"
         id="0v_53"
         inkscape:label="0v_53"><tspan
         sodipodi:role="line"
         id="tspan4654-8-9"
         x="140.85754"
         y="237.30342"
         style="fill:#000;fill-opacity:1;stroke-width:0.264583">0V</tspan></text>
      <path
         style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
         d="m 129.64582,241.4375 h 10.58334"
         id="embrk_line_1"
         inkscape:connector-curvature="0"
         inkscape:label="embrk_line_1" />
      <path
         style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
         d="m 138.64166,240.37917 1.85208,1.05833 -1.85208,1.05834"
         id="arrow_61"
         inkscape:connector-curvature="0"
         inkscape:label="arrow_61" />
      <text
         xml:space="preserve"
         style="font-style:normal;font-weight:normal;font-size:3.52778px;line-height:1.25;font-family:sans-serif;letter-spacing:0px;word-spacing:0px;fill:#000000;fill-opacity:1;stroke:none;stroke-width:0.264583"
         x="140.85754"
         y="242.59508"
         id="0v_61"
         inkscape:label="0v_61"><tspan
         sodipodi:role="line"
         id="tspan4654-8-92"
         x="140.85754"
         y="242.59508"
         style="fill:#000;fill-opacity:1;stroke-width:0.264583">0V</tspan></text>
      <circle
         style="opacity:1;fill:#000;fill-opacity:1;fill-rule:evenodd;stroke:#000;stroke-width:0.26499999;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:markers fill stroke"
         id="dot_r1"
         cx="100.56188"
         cy="225.55878"
         r="0.36750001"
         inkscape:label="dot_r1" />
      <circle
         style="opacity:1;fill:#000;fill-opacity:1;fill-rule:evenodd;stroke:#000;stroke-width:0.26499999;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:markers fill stroke"
         id="dot_r3"
         cx="105.85355"
         cy="225.55878"
         r="0.36750001"
         inkscape:label="dot_r3" />
      <g
         id="LKMF_voltage_blue_color"
         inkscape:label="LKMF_voltage_blue_color">
         <title
            id="title1353">LKMF_voltage_blue_color</title>
         <path
            style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            d="m 121.64218,204.39584 h -13.49374 l 0.33073,79.37499 H 39.6875"
            id="lkmf_line_2"
            inkscape:connector-curvature="0"
            inkscape:label="lkmf_line_2"
            sodipodi:nodetypes="cccc" />
         <path
            style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            d="m 126.93385,204.39584 h 15.87499"
            id="lkmf_line_3"
            inkscape:connector-curvature="0"
            inkscape:label="lkmf_line_3" />
         <path
            style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            d="m 130.175,214.97917 h 17.99166 v -15.875 h 11.37709"
            id="kmf_u_line"
            inkscape:connector-curvature="0"
            inkscape:label="kmf_u_line" />
         <path
            style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            d="M 42.333333,252.02083 H 95.249999 V 236.14584 H 121.70833"
            id="run_line"
            inkscape:connector-curvature="0"
            inkscape:label="run_line" />
         <path
            style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            d="m 129.64583,236.14584 h 10.58333"
            id="run_line_1"
            inkscape:connector-curvature="0"
            inkscape:label="run_line_1" />
         <path
            style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            d="m 129.64583,225.5625 h 10.58333 v -5.29166"
            id="r2_line"
            inkscape:connector-curvature="0"
            inkscape:label="r2_line" />
         <path
            style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            d="M 129.64583,230.85417 H 142.875 v -15.875"
            id="r4_line"
            inkscape:connector-curvature="0"
            inkscape:label="r4_line" />
         <path
            style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            d="m 42.333333,257.3125 h 63.499997 v -15.875 h 15.875"
            id="embrk_line"
            inkscape:connector-curvature="0"
            sodipodi:nodetypes="cccc"
            inkscape:label="embrk_line" />
         <path
            style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            d="m 129.91041,220.27084 h 20.90209 v -15.875 h 8.73125"
            id="kmf_v_line"
            inkscape:connector-curvature="0"
            inkscape:label="kmf_v_line" />
         <path
            style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            d="m 179.91666,241.4375 h 2.64584 v 21.16667 H 50.270833 v -23.8125 h -7.9375"
            id="l161_line"
            inkscape:connector-curvature="0"
            inkscape:label="l161_line"
            sodipodi:nodetypes="cccccc" />
      </g>
      <circle
         style="opacity:1;fill:#000;fill-opacity:1;fill-rule:evenodd;stroke:#000;stroke-width:0.26499999;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:markers fill stroke"
         id="dot_r2"
         cx="140.24937"
         cy="220.26711"
         r="0.36750001"
         inkscape:label="dot_r2" />
      <circle
         style="opacity:1;fill:#000;fill-opacity:1;fill-rule:evenodd;stroke:#000;stroke-width:0.26499999;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:markers fill stroke"
         id="dot_r4"
         cx="142.89522"
         cy="214.97545"
         r="0.36750001"
         inkscape:label="dot_r4" />
      <g
         id="LKMC_voltage_blue_color"
         inkscape:label="LKMC_voltage_blue_color">
         <title
            id="title1082">LKMC_voltage_blue_color</title>
         <path
            style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            d="M 71.437498,204.39584 H 42.333333"
            id="LKMC_line_1"
            inkscape:connector-curvature="0"
            inkscape:label="LKMC_line_1" />
         <path
            style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            d="M 76.729166,204.39584 H 92.604161"
            id="LKMC_line_2"
            inkscape:connector-curvature="0"
            inkscape:label="LKMC_line_2" />
         <path
            style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            d="M 79.639582,220.27084 H 121.70833"
            id="kmc_v_line"
            inkscape:connector-curvature="0"
            inkscape:label="kmc_v_line" />
         <path
            style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            d="M 79.639582,214.97917 H 100.54167 V 249.375 h 52.91666 v -39.6875 h 6.35"
            id="kmc_w_line"
            inkscape:connector-curvature="0"
            inkscape:label="kmc_w_line"
            sodipodi:nodetypes="cccccc" />
         <path
            style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            d="m 79.639581,225.5625 h 18.256251 v 26.45833 h 74.083338 l -1e-5,-10.58333 h 2.64584"
            id="l160_line_2"
            inkscape:connector-curvature="0"
            inkscape:label="l160_line_2"
            sodipodi:nodetypes="cccccc" />
         <path
            style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            d="M 121.70833,225.5625 H 100.54167"
            id="kmc_w_line_1"
            inkscape:connector-curvature="0"
            inkscape:label="kmc_w_line_1" />
         <path
            style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            d="m 121.70833,230.85417 h -15.875 v -5.29167"
            id="kmc_w_line_2"
            inkscape:connector-curvature="0"
            inkscape:label="kmc_w_line_2" />
         <path
            style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
            d="m 42.333333,244.08333 h 15.875 v -13.22916 h 13.229166"
            id="onkmc_line"
            inkscape:connector-curvature="0"
            inkscape:label="onkmc_line" />
      </g>
      <path
         style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
         d="m 184.67916,216.71458 h 10.05417 V 177.9375 H 5.2916666 v 31.75 h 7.9375004"
         id="brc2_line"
         inkscape:connector-curvature="0"
         sodipodi:nodetypes="cccccc"
         inkscape:label="brc2_line" />
      <g
         id="brc0_line"
         inkscape:label="brc0_line">
         <path
            sodipodi:nodetypes="cccc"
            inkscape:connector-curvature="0"
            id="path5027"
            d="m 184.67916,215.12708 h 7.40834 V 183.22917 H 13.229167 10.583333 v 15.875 h 2.645834"
            style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
         <path
            inkscape:connector-curvature="0"
            id="path5029"
            d="m 169.59791,191.96042 h -2.91041 v -8.73125"
            style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1" />
      </g>
      <circle
         style="opacity:1;fill:#000;fill-opacity:1;fill-rule:evenodd;stroke:#000;stroke-width:0.26499999;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1;paint-order:markers fill stroke"
         id="dot_r4-8"
         cx="166.70129"
         cy="183.27222"
         r="0.36750001"
         inkscape:label="dot_r4" />
      <path
         style="fill:none;stroke:#000;stroke-width:0.26458332px;stroke-linecap:butt;stroke-linejoin:miter;stroke-opacity:1"
         d="m 169.59791,193.8125 h -5.55625 V 180.58333 H 7.9374999 v 5.29167 18.52083 h 5.2916671"
         id="brc1_line"
         inkscape:connector-curvature="0"
         sodipodi:nodetypes="ccccc"
         inkscape:label="brc1_line" />
      <text
         hidden="true"
         xml:space="preserve"
         style="font-style:normal;font-weight:normal;font-size:1.41111px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;display:inline;fill:#ff0000;fill-opacity:1;stroke:none;stroke-width:0.264583"
         x="124"
         y="295"
         id="kmf_welded_alert_text"
         inkscape:label="kmf_welded_alert_text">
         <tspan
         sodipodi:role="line"
         x="124"
         y="295"
         style="font-size:4.23333px;fill:#ff0000;fill-opacity:1;stroke-width:0.264583"
         id="tspan4553-0-0">Контактор</tspan>
         <tspan
         sodipodi:role="line"
         x="124"
         y="300"
         style="font-size:4.23333px;fill:#ff0000;fill-opacity:1;stroke-width:0.264583"
         id="tspan4557-2-3">
         заварен
         </tspan>
      </text>
      <text
         hidden="true"
         xml:space="preserve"
         style="font-style:normal;font-weight:normal;font-size:4.23333px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;display:inline;fill:#ff0000;fill-opacity:1;stroke:none;stroke-width:0.264583"
         x="124"
         y="295"
         id="kmf_break_alert_text"
         inkscape:label="kmf_break_alert_text"><tspan
         sodipodi:role="line"
         id="tspan4559-6-0"
         x="124"
         y="295"
         style="font-size:4.23333px;fill:#ff0000;fill-opacity:1;stroke-width:0.264583">Контактор</tspan><tspan
         sodipodi:role="line"
         x="124"
         y="300"
         style="font-size:4.23333px;fill:#ff0000;fill-opacity:1;stroke-width:0.264583"
         id="tspan4563-1-7">неисправен</tspan></text>
      <text
         hidden="true"
         xml:space="preserve"
         style="font-style:normal;font-weight:normal;font-size:4.23333px;line-height:1.25;font-family:sans-serif;text-align:center;letter-spacing:0px;word-spacing:0px;text-anchor:middle;display:inline;fill:#ff0000;fill-opacity:1;stroke:none;stroke-width:0.264583"
         x="74.780792"
         y="295"
         id="kms_break_alert_text"
         inkscape:label="kms_break_alert_text"><tspan
         sodipodi:role="line"
         id="tspan4559-6-0-8"
         x="74.780792"
         y="295"
         style="font-size:4.23333px;fill:#ff0000;fill-opacity:1;stroke-width:0.264583">Контактор</tspan><tspan
         sodipodi:role="line"
         x="74.780792"
         y="300"
         style="font-size:4.23333px;fill:#ff0000;fill-opacity:1;stroke-width:0.264583"
         id="tspan4563-1-7-5">неисправен</tspan></text>
   </g>
</svg>
`

export default liftWinchPowerSrc
